"use strict";

var _taggedTemplateLiteral = require("/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenRefreshMutation = exports.tokenVeryficationMutation = exports.tokenAuthMutation = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var errors_1 = require("../fragments/errors");

exports.tokenAuthMutation = graphql_tag_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  mutation TokenAuth($email: String!, $password: String!) {\n    tokenCreate(email: $email, password: $password) {\n      csrfToken\n      refreshToken\n      token\n      errors: accountErrors {\n        ...AccountError\n      }\n      user {\n        id\n      }\n    }\n  }\n"])), errors_1.accountErrorFragment);
exports.tokenVeryficationMutation = graphql_tag_1.default(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  mutation VerifyToken($token: String!) {\n    tokenVerify(token: $token) {\n      isValid\n      payload\n      user {\n        id\n      }\n      errors: accountErrors {\n        ...AccountError\n      }\n    }\n  }\n"])), errors_1.accountErrorFragment);
exports.tokenRefreshMutation = graphql_tag_1.default(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  mutation RefreshToken($csrfToken: String, $refreshToken: String) {\n    tokenRefresh(csrfToken: $csrfToken, refreshToken: $refreshToken) {\n      token\n      user {\n        id\n      }\n      errors: accountErrors {\n        ...AccountError\n      }\n    }\n  }\n"])), errors_1.accountErrorFragment);